import { format, getDate, getYear } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { parseDate } from 'helpers/date';
import { EventDates as EventDatesType } from 'interfaces/event';
import React from 'react';

interface EventDatesFormatedProps {
  eventDates: EventDatesType[];
}

const EventDatesFormated = ({ eventDates }: EventDatesFormatedProps) => {
  const eventDatesFormated = (): string => {
    if (eventDates?.length > 1) {
      const initialDate = parseDate(eventDates[0].date);
      const finalDate = parseDate(eventDates[eventDates.length - 1].date);
      const initialDay = getDate(initialDate);
      const initialMonth = format(initialDate, 'LLLL', { locale: ptBR });
      const finishDay = getDate(finalDate);
      const finishMonth = format(finalDate, 'LLLL', { locale: ptBR });
      const finishYear = getYear(finalDate);

      return `de ${initialDay} de ${initialMonth} à ${finishDay} de ${finishMonth} de ${finishYear}`;
    }

    if (eventDates?.length === 1) {
      const initialDate = parseDate(eventDates[0].date);
      const initialDay = getDate(initialDate);
      const initialMonth = format(initialDate, 'LLLL', { locale: ptBR });

      return `${initialDay} de ${initialMonth}`;
    }

    return '-';
  };

  return <>{eventDatesFormated()}</>;
};

export default EventDatesFormated;
